// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".partner-container[data-v-4b7f47ca]{width:100%;max-width:220px}.partner-container p[data-v-4b7f47ca]{opacity:0;transition:opacity .5s}@media (min-width:600px){.partner-container:hover img[data-v-4b7f47ca]{transform:scale(1.2)}.partner-container:hover p[data-v-4b7f47ca]{opacity:1}}.partner-container img[data-v-4b7f47ca]{width:100%;transition:all .5s}", ""]);
// Exports
module.exports = exports;
